import { useMutation } from '@tanstack/react-query';
import { GET, GET_CUSTOMER_LINE } from '../../services';
import { openAlert } from '../../components/alert/hooks';

export const useGetCustomer = () => {
  return useMutation({
    mutationFn: async ({ userId }) => {
      const response = await GET(GET_CUSTOMER_LINE(userId));
      return response;
    },
    onError: (error) => {
      openAlert({
        message: error?.message,
        type: 'error',
      });
    },
  });
};
